import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

/**
 * Guard that redirects to /register on first launch, otherwise allows navigation.
 * Use this guard on the /login route to redirect first-time users to register.
 */
export const firstLaunchGuard: CanActivateFn = (_route, _state) => {
	const authService = inject(AuthenticationService);
	const router = inject(Router);

	return from(authService.isFirstLaunch()).pipe(
		map(isFirstLaunch => {
			if (isFirstLaunch) {
				router.navigateByUrl('/register', { replaceUrl: true });
				return false;
			}
			return true;
		}),
	);
};
